import Component from "../core/Component";
import support from "../utils/BrowserSupport";
import enquire from "enquire.js";
import { queries } from "../core/config";

export const STATES = {
	ACTIVE: "is-active",
};

export default class CollapseAccordion extends Component {
	constructor(element) {
		super(element);

		this.ref = {
			items: [],
			toggles: [],
			contents: [],
		};

		if (this.element.dataset.options) {
			const options = JSON.parse(this.element.dataset.options) || {};

			this.options = {
				...this.options,
				...options,
			};
		}
		this.isDesktop = true;

		this.enquireHandler = {
			match: () => {
				this.isDesktop = false;
			},
			unmatch: () => {
				this.isDesktop = true;
			},
		};
	}

	prepare() {
		enquire.register(queries.smallUp, this.enquireHandler);
		this.ref.toggles.forEach((toggle) => toggle.addEventListener("click", ::this.handleToggleClick));
		this.ref.items.forEach((item, index) => this.close(index, true));
	}

	handleToggleClick(event) {
		if (!this.isDesktop) {
			event.preventDefault();
			const index = this.ref.toggles.indexOf(event.currentTarget);
			this.toggle(index);
		}
	}

	toggle(itemIndex) {
		const item = this.ref.items[itemIndex];

		if (item.classList.contains('collapse-accordion__item--dead')) {
			return false;
		}

		if (item.classList.contains(STATES.ACTIVE)) {
			this.close(itemIndex);
		} else {
			this.open(itemIndex);
		}
	}

	open(itemIndex) {
		const item = this.ref.items[itemIndex];
		const content = this.ref.contents[itemIndex];
		item.classList.add(STATES.ACTIVE);

		content.style.height = `${content.scrollHeight}px`;

		this.ref.items.forEach((item, index) => {
			if (index !== itemIndex) {
				this.close(index);
			}
		});
	}

	close(itemIndex, force = false) {
		if (force || this.ref.items[itemIndex].classList.contains(STATES.ACTIVE)) {
			this.ref.items[itemIndex].classList.remove(STATES.ACTIVE);
			if (!this.isDesktop) {
				this.ref.contents[itemIndex].style.height = "0px";
			} else {
				this.ref.contents[itemIndex].removeAttribute("style");
			}
		}
	}
}
